<template>
	<div class="page">
		<el-form label-width="90px">
			<el-form-item label="背景图片">
				<el-input v-model="curSelData.bgUrl" placeholder="请输入图片地址">
					<template slot="append"><span style="cursor: pointer"
							@click="selImg('scanFive','bgUrl')">选择图片</span></template>
				</el-input>
				<el-col :span="18">
					<img :src="curSelData.bgUrl" alt="" class="imgClass">
				</el-col>
			</el-form-item>
			<el-form-item label="logo图片">
				<el-input v-model="curSelData.logoUrl" placeholder="请输入图片地址">
					<template slot="append"><span style="cursor: pointer"
							@click="selImg('scanFive','logoUrl')">选择图片</span></template>
				</el-input>
				<el-col :span="18">
					<img :src="curSelData.logoUrl" alt="" class="imgClass">
				</el-col>
			</el-form-item>
			<el-form-item label="logo宽">
				<template>
					<bs-slider v-model="curSelData.logoWidth" :min="0" :max="100" />
				</template>
			</el-form-item>
			<el-form-item label="标题图片">
				<el-input v-model="curSelData.titleUrl" placeholder="请输入图片地址">
					<template slot="append"><span style="cursor: pointer"
							@click="selImg('scanFive','titleUrl')">选择图片</span></template>
				</el-input>
				<el-col :span="18">
					<img :src="curSelData.titleUrl" alt="" class="imgClass">
				</el-col>
			</el-form-item>
			<el-form-item label="标题宽">
				<template>
					<bs-slider v-model="curSelData.titleWidth" :min="0" :max="500" />
				</template>
			</el-form-item>
			<el-form-item label="内容背景">
				<el-input v-model="curSelData.contentUrl" placeholder="请输入图片地址">
					<template slot="append"><span style="cursor: pointer"
							@click="selImg('scanFive','contentUrl')">选择图片</span></template>
				</el-input>
				<el-col :span="18">
					<img :src="curSelData.contentUrl" alt="" class="imgClass">
				</el-col>
			</el-form-item>

			<el-form-item label="内容图片">
				<el-input v-model="curSelData.textUrl" placeholder="请输入图片地址">
					<template slot="append"><span style="cursor: pointer"
							@click="selImg('scanFive','textUrl')">选择图片</span></template>
				</el-input>
				<el-col :span="18">
					<img :src="curSelData.textUrl" alt="" class="imgClass">
				</el-col>
			</el-form-item>


			<el-form-item label="标题文字颜色" class="formsItem">
				<template>
					<bs-color-picker v-model="curSelData.titleColor" style="float:left;" />
					<el-button type="primary" class="btnClear" @click="clearColor('titleColor')">清除</el-button>
				</template>
			</el-form-item>
			
			<el-form-item label="内容文字颜色" class="formsItem">
				<template>
					<bs-color-picker v-model="curSelData.contentColor" style="float:left;" />
					<el-button type="primary" class="btnClear" @click="clearColor('contentColor')">清除</el-button>
				</template>
			</el-form-item>
			<el-form-item>
				<el-card v-for="(item,index) in curSelData.contentList" :key="index">
					<div slot="header" class="clearfix">
						<el-button style="float: right; padding: 3px 0" type="text"
							@click="delContent(index)">删除</el-button>
					</div>
					<el-form-item label="标题">
						<el-input v-model="item.name" type="text" placeholder="请输入标题" />
					</el-form-item>
					<el-form-item label="内容">
						<el-input v-model="item.info" type="text" placeholder="请输入标题" />
					</el-form-item>


				</el-card>
				<el-button style="margin:20px auto;width: 80%;display: block;" @click="addContent">添加一项</el-button>
			</el-form-item>
			<el-form-item label="标题1文字颜色" class="formsItem">
				<template>
					<bs-color-picker v-model="curSelData.title1Color" style="float:left;" />
					<el-button type="primary" class="btnClear" @click="clearColor('title1Color')">清除</el-button>
				</template>
			</el-form-item>
			<el-form-item label="按钮图片">
				<el-input v-model="curSelData.anUrl" placeholder="请输入图片地址">
					<template slot="append"><span style="cursor: pointer"
							@click="selImg('scanFive','anUrl')">选择图片</span></template>
				</el-input>
				<el-col :span="18">
					<img :src="curSelData.anUrl" alt="" class="imgClass">
				</el-col>
			</el-form-item>
		</el-form>

	</div>
</template>
<script>
	import BsSlider from '../module/BsSlider'
	import BsColorPicker from '../module/BsColorPicker'
	export default {
		props: {
			curSelData: {
				type: Object,
				// eslint-disable-next-line vue/require-valid-default-prop
				default: () => {}
			}
		},
		components: {
			BsSlider,
			BsColorPicker
		},
		data() {
			return {

			}
		},
		methods: {
			clearColor(attr) {
				console.log(this.curSelData[attr])
				if (attr == 'titleColor') {
					this.curSelData[attr] = '#0D525B'
				} else if (attr == 'title1Color') {
					this.curSelData[attr] = '#0D525B'
				} else if (attr == 'contentColor') {
					this.curSelData[attr] = '#05272B'
				}
			},
			selImg(type, attr) {
				this.$emit('selImg', type, attr)
			},
			addContent() {
				this.curSelData.contentList.push({
					name: '标题',
					info: '内容'
				})
			},
			delContent(index) {
				this.curSelData.contentList.splice(index, 1)
			},

		}
	}
</script>
<style scoped>
	.imgClass {
		width: 100px;
		height: auto;
		margin: 15px 0;
	}
</style>